/* Multi-Solar categoriebalk: open op hover (desktop), sluit bij klik buiten of Escape. */
(() => {
  const nav = document.querySelector('.mts-nav');
  if (!nav) return;

  const hoverMogelijk = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const SLUIT_VERTRAGING = 140;

  const sluitAlles = (behalve) => {
    nav.querySelectorAll('details[open]').forEach((d) => {
      if (d !== behalve) {
        d.removeAttribute('open');
        d.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      }
    });
  };

  nav.querySelectorAll('header-menu').forEach((menu) => {
    const details = menu.querySelector('details');
    const summary = details.querySelector('summary');
    let timer;

    const open = () => {
      clearTimeout(timer);
      sluitAlles(details);
      if (!details.open) {
        details.open = true;
        summary.setAttribute('aria-expanded', 'true');
      }
    };
    const sluit = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
      }, SLUIT_VERTRAGING);
    };

    if (hoverMogelijk) {
      menu.addEventListener('mouseenter', open);
      menu.addEventListener('mouseleave', sluit);
    }

    // Met muis: paneel opent al op hover, dus een klik op het menu-item gaat naar de categoriepagina.
    // Zonder hover (touch): klik opent/sluit het paneel zoals gewoonlijk.
    summary.addEventListener('click', (e) => {
      if (hoverMogelijk && details.open && summary.dataset.mtsUrl) {
        e.preventDefault();
        window.location.href = summary.dataset.mtsUrl;
        return;
      }
      sluitAlles(details);
    });

  });

  document.addEventListener('click', (e) => {
    if (!nav.contains(e.target)) sluitAlles();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') sluitAlles();
  });
})();
